import React from 'react';
import styled from 'styled-components';
import Pagination, { PaginationProps } from '@mui/material/Pagination';

const StylePagination = styled(Pagination)<{
    props: PaginationProps;
}>`
    &.MuiPagination-root {
        width: fit-content;
        margin: 0 auto;
        .MuiPagination-ul {
            padding-inline-start: 0;
            li {
                button,
                .MuiPaginationItem-root {
                    color: white;
                    background: rgba(255, 255, 255, 0.1);
                    border: none;
                    border-radius: 6px;
                    min-width: 40px;
                    height: 40px;
                    font-size: 14px;
                    font-weight: 500;
                    margin: 0 4px;
                    transition: all 0.2s ease;

                    &:hover {
                        background: rgba(255, 255, 255, 0.2);
                    }
                }

                .Mui-selected {
                    color: white;
                    background: transparent;
                    border: 2px solid rgba(247, 147, 26, 1);
                    border-radius: 6px;
                }

                .MuiPaginationItem-firstLast {
                    color: white;
                }

                .MuiPaginationItem-previousNext {
                    color: white;
                }

                .MuiPaginationItem-ellipsis {
                    color: white;
                    background: rgba(255, 255, 255, 0.1);
                    border: none;
                    border-radius: 6px;
                    min-width: 40px;
                    height: 40px;
                    font-size: 14px;
                    font-weight: 500;
                    margin: 0 4px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.2s ease;

                    &:hover {
                        background: rgba(255, 255, 255, 0.2);
                    }
                }
            }
        }
    }
`;

interface Props {
    pageSize?: number;
}

export default function MaterialTablePagination(props: Props) {
    const { pageSize = 10 } = props;

    function onChange(e: any, page: number) {
        (props as any).onPageChange(e, page - 1);
    }

    const totalCount = (props as any).count || 0;
    const totalPages = totalCount > 0 ? Math.ceil(totalCount / pageSize) : 1;

    return (
        <StylePagination
            {...(props as any)}
            page={(props as any).page + 1}
            count={totalPages}
            onChange={onChange}
            defaultPage={0}
        />
    );
}
